import { useEffect, useRef, useState } from "react";

const useLiveLocation = ({
  enableHighAccuracy = true,
  timeout = 15000,
  maximumAge = 0,
} = {}) => {
  const [location, setLocation] =
    useState(null);

  const [error, setError] =
    useState(null);

  const [loading, setLoading] =
    useState(true);

  const watchIdRef = useRef(null);

  useEffect(() => {
    if (!navigator.geolocation) {
      setError(
        "Geolocation not supported."
      );

      setLoading(false);

      return;
    }

    watchIdRef.current =
      navigator.geolocation.watchPosition(
        (position) => {
          setLocation({
            latitude:
              position.coords.latitude,

            longitude:
              position.coords.longitude,

            accuracy:
              position.coords.accuracy,

            speed:
              position.coords.speed,

            heading:
              position.coords.heading,

            timestamp:
              position.timestamp,
          });

          setLoading(false);
        },

        (err) => {
          setError(err.message);

          setLoading(false);
        },

        {
          enableHighAccuracy,
          timeout,
          maximumAge,
        }
      );

    return () => {
      if (watchIdRef.current) {
        navigator.geolocation.clearWatch(
          watchIdRef.current
        );
      }
    };
  }, []);

  return {
    location,
    error,
    loading,
  };
};

export default useLiveLocation;